// @flow

import axios from 'axios';
import AuthAPI from 'api/AuthAPI';
import { setAuthMsg } from './authMsg';
import storageHelper from 'helpers/storage.helper';
import authErrorHelper from 'helpers/authError.helper';
import { userUpdatePasswordSuccess, userUpdatePasswordFailure } from 'actions/user/user';


export const registerUser = (email: string, password: string, passwordConfirmation: string, history: any) => {
  return (dispatch: any, getState: any) => {
    AuthAPI.registerPost(email, password, passwordConfirmation, window.location.origin + '/session/login').then(res => {
      let { data: { data: user }, headers } = res;
      dispatch({ type: 'LOGIN', user, headers });
      history.push({ pathname: '/session/register/success', state: { registeredEmail: user.email } });
    })
      .catch(res => {
        const messages = authErrorHelper.message(res, authErrorHelper.translateFromState(getState));
        dispatch(setAuthMsg(messages, 'danger', true));
      });
  }
}

export const confirmEmail = (email: string, history: any) => {
  return (dispatch: any, getState: any) => {
    return AuthAPI.confirmEmail(email, window.location.origin + '/session/login').then(res => {
      let { data: { data: user } } = res;
      history.push({ pathname: '/session/confirmation/success', state: { registeredEmail: user.email } });
    })
      .catch(res => {
        const messages = authErrorHelper.message(res, authErrorHelper.translateFromState(getState));
        dispatch(setAuthMsg(messages, 'danger', true));
      });
  }
}

export const editPassword = (oldPassword: string, newPassword: string, newPasswordConfirmation: string) => {
  return (dispatch: any) => {
    return AuthAPI.editPassword(oldPassword, newPassword, newPasswordConfirmation).then(res => {
      dispatch(userUpdatePasswordSuccess());
    }).catch(err => {
      dispatch(userUpdatePasswordFailure());
    });
  }
}

export const handleLogout = (history: any) => {
  return (dispatch: any, getState: any) => {
    AuthAPI.logoutPost().then(res => {
      dispatch({ type: 'LOGOUT' });
      storageHelper.destroyStorage();
    })
      .catch(res => {
        const messages = authErrorHelper.message(res, authErrorHelper.translateFromState(getState));
        dispatch(setAuthMsg(messages, 'danger'));
      });
  }
}

export const handleLogin = (email: string, password: string, remember: bool, history: any) => {
  return (dispatch: any, getState: any) => {
    AuthAPI.loginPost(email, password, remember).then(res => {
      let { data: { data: user }, headers } = res;
      dispatch({ type: 'LOGIN', user, headers });
      history.push('/');
    }).catch(res => {
      const messages = authErrorHelper.message(res, authErrorHelper.translateFromState(getState));
      const failedAttempts = res && res.response && res.response.data ? res.response.data.failed_attempts : undefined;
      dispatch(setAuthMsg(messages, 'danger', false, false, 'email', failedAttempts));
    });
  }
}

export const requestResetPassword = (email: string, history: any) => {
  return (dispatch: any, getState: any) => {
    return AuthAPI.requestPassword(email, window.location.origin + '/session/reset-password/new').then(res => {
      history.push({ pathname: '/session/reset-password/success', state: { requestedEmail: email } });
    })
      .catch(res => {
        const messages = authErrorHelper.message(res, authErrorHelper.translateFromState(getState));
        dispatch(setAuthMsg(messages, 'danger', true));
      });
  }
}

export const resetPassword = (password: string, resetPasswordToken: string, headers: any, history: any) => {
  return (dispatch: any, getState: any) => {
    return AuthAPI.resetPassword(password, resetPasswordToken, headers).then(res => {
      if (res !== 'undefined') {
        let { data: { data: user }, headers } = res

        dispatch({ type: 'LOGIN', user, headers });
        history.push('/');
      }
    }).catch(res => {
      const messages = authErrorHelper.message(res, authErrorHelper.translateFromState(getState), 'session.error.password_not_saved');
      dispatch(setAuthMsg(messages, 'danger', true));
    });
  }
}

export const unlockAccount = (email: string, history: any) => {
  return (dispatch: any, getState: any) => {
    AuthAPI.unlockAccount(email, window.location.origin + '/session/login').then(res => {
      if (res !== 'undefined') {
        history.push('/session/login');
      }
    })
      .catch(res => {
        const messages = authErrorHelper.message(res, authErrorHelper.translateFromState(getState));
        dispatch(setAuthMsg(messages, 'danger', false, true));
      });
  }
}

export const unlockAccountByToken = (unlock_token: string, history: any) => {
  return (dispatch: any, getState: any) => {
    return AuthAPI.unlockAccountByToken(unlock_token).then(res => {
      if (res !== 'undefined') {
        history.push('/session/login?account_unlocked=1');
      }
    })
      .catch(res => {
        const translate = authErrorHelper.translateFromState(getState);
        // Expired, already used or invalid token - Devise's raw text is not helpful for the customer
        const messages = authErrorHelper.isClientError(res)
          ? authErrorHelper.translate(translate, 'session.unlock.error_link_expired_or_used')
          : authErrorHelper.message(res, translate);
        dispatch(setAuthMsg(messages, 'danger', true));
      });
  }
}

export const validateToken = (cb: any = f => f) => {
  return (dispatch: any) => {
    dispatch({ type: 'VALIDATE_TOKEN' });
    let headers = axios.defaults.headers.common;
    AuthAPI.validateTokenPost(headers).then(res => {
      dispatch({ type: 'LOGIN', user: res.data.data });
    })
      .catch(() => cb());
  }
}

export const resetUserLoading = () => {
  return (dispatch: any) => {
    dispatch({ type: 'USER_RESET_LOADING' });
  }
}



// WEBPACK FOOTER //
// ./src/actions/session/userAuth.js